module.exports = __webpack_public_path__ + "static/media/mypage-dark.e4e5951e.svg";